import { Dialog, DialogContent, DialogTitle } from '@evaneos/b2b-ui';
import { useEffect, useState } from 'react';

import { FormattedMessage } from 'react-intl';

import {
    AgentWorkloadReminder,
    AgentWorkloadReminderType,
} from '../domain/collectCapacityReminder/CollectCapacityReminderConfigurator';

import { logModalOpened, logModalClosed } from '../logging';
import { useGetLoggedAgent } from '../../agent/hooks';

import { AgentWorkloadForm } from './AgentWorkloadForm';

interface Props {
    reminder: AgentWorkloadReminder | null;
}

export const NoAgentWorkloadFeedbackForTwoWeeksModal = ({ reminder }: Props) => {
    const [open, setOpen] = useState(false);
    const agent = useGetLoggedAgent();

    const [prevReminder, setPrevReminder] = useState(reminder);
    if (prevReminder !== reminder) {
        setPrevReminder(reminder);
        if (
            reminder &&
            reminder.type === AgentWorkloadReminderType.NoFeedbackForTwoWeeks &&
            reminder.remindAt < new Date()
        ) {
            setOpen(true);
        }
    }

    useEffect(() => {
        if (
            reminder &&
            reminder.type === AgentWorkloadReminderType.NoFeedbackForTwoWeeks &&
            reminder.remindAt < new Date()
        ) {
            logModalOpened(
                'NoAgentWorkloadFeedbackForTwoWeeksModal',
                {
                    reminderType: reminder.type,
                    remindAt: reminder.remindAt,
                },
                agent,
            );
        }
    }, [reminder, agent]);

    const handleClose = (_event: object, reason?: 'backdropClick' | 'escapeKeyDown') => {
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
            return;
        }
        logModalClosed(
            'NoAgentWorkloadFeedbackForTwoWeeksModal',
            {
                action: 'choice_made',
            },
            agent,
        );
        setOpen(false);
    };

    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xs">
            <DialogTitle>
                <p
                    style={{
                        fontSize: `2.2rem`,
                        lineHeight: `3rem`,
                    }}
                >
                    <FormattedMessage
                        id={
                            'agent_settings.workload_status.reminder.no_feedback_for_two_weeks.title'
                        }
                    />
                </p>
                <p
                    style={{
                        fontSize: `1.6rem`,
                        lineHeight: `2rem`,
                        color: `var(--ink-light)`,
                    }}
                >
                    <FormattedMessage
                        id={
                            'agent_settings.workload_status.reminder.no_feedback_for_two_weeks.sub_title'
                        }
                    />
                </p>
            </DialogTitle>
            <DialogContent>
                <AgentWorkloadForm
                    onChoiceHandled={() => handleClose({})}
                    overloadedButtonLabel={
                        'agent_settings.workload_status.reminder.no_feedback_for_two_weeks.overloaded'
                    }
                    underloadedButtonLabel={
                        'agent_settings.workload_status.reminder.no_feedback_for_two_weeks.underloaded'
                    }
                    goodButtonLabel={
                        'agent_settings.workload_status.reminder.no_feedback_for_two_weeks.good'
                    }
                />
            </DialogContent>
        </Dialog>
    );
};
